// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__HzBxV","fade-in":"Modal_fade-in__ayLFJ","wrapper":"Modal_wrapper__BzZtk"};